export default __webpack_public_path__ + "static/media/signal_bad.7348fda2.svg";